/**
 * @Author: Elias Kautto
 * @Date:   2023-05-02 13:48:26
 * @Last Modified by:   Elias Kautto
 * @Last Modified time: 2023-05-02 13:55:01
 */
/**
 * Air theme JavaScript.
 */

// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');

// Init lazyload
// Usage example on template side when air-helper enabled:
// <?php image_lazyload_tag( get_post_thumbnail_id( $post->ID ) ); ?>
let images = document.querySelectorAll('.lazyload');
lazyload(images, {
 root: null,
 rootMargin: "0px",
 threshold: 0
});

// jQuery start
( function( $ ) {

    $(document).ready(function() {

    // Gallery
    var galleryelement = document.getElementsByClassName('wp-block-gallery')[0];
    if (typeof(galleryelement) != 'undefined' && galleryelement != null) {
      document.getElementsByClassName('wp-block-gallery')[0].onclick = function (event) {
        event = event || window.event;
        var target = event.target || event.srcElement,
        link = target.src ? target.parentNode : target,
        options = {
          index: link,
          event: event,
          fullScreen: false,
          toggleControlsOnSlideClick: false,
          stretchImages: 'cover',
          onopen: function (index, slide) {
            current = this.getIndex();
            total = this.getNumber();
            document.getElementById('pos').textContent = current + 1;
            document.getElementById('count').textContent = total;
          },
          onslide: function (index, slide) {
            current = this.getIndex();
            total = this.getNumber();
            document.getElementById('pos').textContent = current + 1;
            document.getElementById('count').textContent = total;
          }
        },
        links = this.getElementsByTagName('a');
        blueimp.Gallery(links, options);
      };
    }
  });

  // Hide or show the "back to top" link
  $(window).scroll(function() {

    // Back to top
    var offset = 300; // Browser window scroll (in pixels) after which the "back to top" link is shown
    var offset_opacity = 1200; // Browser window scroll (in pixels) after which the link opacity is reduced
    var scroll_top_duration = 700; // Duration of the top scrolling animation (in ms)
    var link_class = '.top';

    if( $(this).scrollTop() > offset ) {
      $( link_class ).addClass('is-visible');
    } else {
      $( link_class ).removeClass('is-visible');
    }

    if( $(this).scrollTop() > offset_opacity ) {
      $( link_class ).addClass('fade-out');
    } else {
      $( link_class ).removeClass('fade-out');
    }

  });

  $(window).load(function() {

    // Masonry
    var $container = $('.image-grid').packery({
      initLayout: false,
      itemSelector: '.image'
    });
    $container.packery();

    // Portfolio tabs
    if( '.tabs-content .current' != undefined) {
      var portfolio_height = $('.tabs-content .current').outerHeight();
      $('.tabs-content').css('height', portfolio_height);
    }
  });

  // Document ready start
  $(function() {

    // Set up back to top link
    var moveTo = new MoveTo();
    var target = document.getElementById('target');
    moveTo.move(target);

    // Register a back to top trigger
    var trigger = document.getElementsByClassName('js-trigger')[0];
    moveTo.registerTrigger(trigger);

    // Pure css ul as select dropdown, "<select>"
    // @link https://codepen.io/npmhieu/pen/BLRjdo
    // onClick new options list of new select
    $('.custom-select-content').text($('.dropdown-menu > li.current').text());
    var newOptions = $('.dropdown-menu > li');
    newOptions.click(function() {
      $('.custom-select-content').text($(this).text());
      $('.dropdown-menu > li').removeClass('current');
      $(this).addClass('current');

    // Init masonry
    var $container = $('.image-grid').packery({
      initLayout: false,
      itemSelector: '.image'
    });
    $container.packery();

    });

    var aeDropdown = $('.custom-dropdown');
    aeDropdown.click(function() {
      $('.dropdown-menu').toggleClass('custom-hide');
    });

    // Drop down
    $('ul.tabs .current').click(function() {
      $('ul.tabs').toggleClass('toggled');
    });

    $('ul.tabs li').click(function() {
      var tab_id = $(this).attr('data-tab');

      $('ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');

      if( '.tabs-content .current' != undefined) {
        var portfolio_height = $("#"+tab_id).outerHeight();
        $('.tabs-content').css('height', portfolio_height);
      }

      // Init Masonry
      var $container = $('.image-grid').packery({
        initLayout: false,
        itemSelector: '.image'
      });
      $container.packery();

      // Portfolio tabs
      if( '.tabs-content .current' != undefined) {
        var portfolio_height = $('.tabs-content .current').outerHeight();
        $('.tabs-content').css('height', portfolio_height);
      }
    });

  });

} )( jQuery );
